import {createApp} from 'vue'
import AttachmentsEditor from './AttachmentsEditor'

const el = '.kb-component--community-attachments-editor'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CommunityAttachmentsDOM)=>{
            const props = {
                acceptedFileTypes: CommunityAttachmentsDOM.dataset.acceptedFileTypes,
                files: JSON.parse(CommunityAttachmentsDOM.dataset.files),
                maxAttachments: parseInt(CommunityAttachmentsDOM.dataset.maxAttachments)
            }
            const component = createApp(AttachmentsEditor, props).use(Store)
            component.mount(CommunityAttachmentsDOM)
        })
    }
}